import React from "react";

const PajakindLogo = (props) => {
  return (
    <svg
      className="h-8"
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.29,20.24a2,2,0,1,1-2.86,2.86l-6.76-6.76-1.6-1.59-1.43-1.43-1.43-1.43h0l1.43-1.44L16.07,9l1.6-1.59L24.39.71a2.16,2.16,0,0,1,3-.16,2.16,2.16,0,0,1-.16,3L20.53,10.3a2.26,2.26,0,0,0,0,3.19Z"
        fill="#56b9e9"
      />
      <path
        d="M14.79.92A2.72,2.72,0,0,1,18.62.76a2.72,2.72,0,0,1-.16,3.83L4.56,18.49a2.72,2.72,0,0,1-3.83.16,2.72,2.72,0,0,1,.16-3.83Z"
        fill="#56b9e9"
      />
      <path
        d="M18.4,19.29a2.72,2.72,0,0,1,.16,3.83A2.72,2.72,0,0,1,14.73,23L8.61,16.85c-1.1-1.1-2-.72-2,.83V21A2.83,2.83,0,0,1,3.8,23.83h-1A2.83,2.83,0,0,1,0,21V2.82A2.83,2.83,0,0,1,2.82,0h1A2.83,2.83,0,0,1,6.62,2.82V4.69a7.84,7.84,0,0,0,2,4.81Z"
        fill="#5b86e5"
      />
    </svg>
  );
};

export default PajakindLogo;
